var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { CLOSE_REASONS, DEFAULT_MANUAL_FORMS_BUTTON_TEXT, USER_INTENT, } from "../../../lib/constants";
import { clickedFillOutFormsManually, completedPage } from "../../../lib/Avo";
import useAppSelector from "../../../hooks/useAppSelector";
function UnderFormContent(_a) {
    var onCloseClick = _a.onCloseClick, onFullFormClick = _a.onFullFormClick;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var _b = useAppSelector(function (state) { return state.configuration; }), enableFormExperience = _b.enableFormExperience, manualFormsButtonText = _b.manualFormsButtonText;
    function handleManualFormButton() {
        clickedFillOutFormsManually(__assign({}, commonAnalyticsProperties));
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: DEFAULT_MANUAL_FORMS_BUTTON_TEXT, optionSelected: DEFAULT_MANUAL_FORMS_BUTTON_TEXT }));
        onCloseClick({
            reason: CLOSE_REASONS.MANUAL_FORMS,
            userIntent: USER_INTENT.PROCEED_MANUALLY,
        });
    }
    return (React.createElement("div", { className: "pt-6 text-center" }, enableFormExperience ? (React.createElement("div", null,
        React.createElement("button", { onClick: onFullFormClick, className: "text-trellis-black underline" }, manualFormsButtonText || DEFAULT_MANUAL_FORMS_BUTTON_TEXT))) : manualFormsButtonText ? (React.createElement("button", { onClick: handleManualFormButton }, manualFormsButtonText)) : null));
}
export default UnderFormContent;
